module.exports = __webpack_public_path__ + "img/zfb.c968c82d.png";